import { render, staticRenderFns } from "./AllFeedback.vue?vue&type=template&id=126eb708&"
import script from "./AllFeedback.vue?vue&type=script&lang=js&"
export * from "./AllFeedback.vue?vue&type=script&lang=js&"
import style0 from "./AllFeedback.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports